import type { InsuranceOffer } from '@backmarket/http-api/src/api-models/InsuranceOffer'
import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { VariantsEnum as TagVariants } from '@ds/components/Tag/Tag.constant'

import translations from './useInsuranceTagProps.translations'

function hasMonthlyTag(offer: InsuranceOffer, countryCode: MarketCountryCode) {
  return (
    offer.paymentFrequency === 'MONTHLY' && countryCode === MarketCountryCode.US
  )
}

function hasMonthlyTags(
  offers: InsuranceOffer[],
  countryCode: MarketCountryCode,
) {
  return offers.some((offer) => hasMonthlyTag(offer, countryCode))
}

export function useInsuranceTagProps(
  offers: InsuranceOffer[],
  index: number,
  countryCode: MarketCountryCode,
) {
  const i18n = useI18n()

  if (hasMonthlyTag(offers[index], countryCode))
    return {
      label: i18n(translations.monthlyPaymentTag),
      variant: TagVariants.Primary,
    }
  if (index === 0 && !hasMonthlyTags(offers, countryCode))
    return {
      label: i18n(translations.recommendedTag),
      variant: TagVariants.Primary,
    }

  return undefined
}
